import React, {
  FC,
  useCallback,
  useContext,
} from 'react';
import { EventDatetimeContext } from 'components/EventDatetime';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectResetEmailModalOpen, setResetEmailModalOpen } from 'models/landing';
import ResetEmailModal from './ResetEmailModal';
import useLandingItems from './useLandingItems';
import LandingPageContent from './LandingPageContent';

const ButtonContainer = styled.div`
  margin-top: 3vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LandingContent: FC = () => {
  const {
    hasEventEnded,
    hasRegisterEnded,
    hasEventStarted,
  } = useContext(EventDatetimeContext);
  const isResetEmailModalOpened = useSelector(selectResetEmailModalOpen);
  const dispatch = useDispatch();

  const openResetEmailModal = useCallback(() => {
    dispatch(setResetEmailModalOpen(true));
  }, [dispatch]);

  const handleResetEmailModalClose = useCallback(() => {
    dispatch(setResetEmailModalOpen(false));
  }, [dispatch]);

  const filteredComponents = useLandingItems(openResetEmailModal);

  return (
    <>
      <ResetEmailModal
        open={isResetEmailModalOpened}
        handleClose={handleResetEmailModalClose}
        hasRegisterEnded={hasRegisterEnded}
      />
      {filteredComponents.header}
      {filteredComponents.eventTitle}
      {filteredComponents.eventDate}
      {filteredComponents.eventTime}
      {!hasEventStarted && filteredComponents.countdown}
      <LandingPageContent id="landing-page-content">
        <ButtonContainer id="landing-button-container">
          {!hasRegisterEnded && filteredComponents.registerButton}
          {hasEventStarted && !hasEventEnded && filteredComponents.registeredButton}
        </ButtonContainer>
      </LandingPageContent>
      {filteredComponents.rtfText}
      {filteredComponents.richTextFields}
    </>
  );
};

export default React.memo(LandingContent);
